
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ProtectedRoute = ({ requiredRole, children }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                // 1. Get User
                const { data: { user }, error } = await supabase.auth.getUser();
                if (error || !user) {
                    setIsAuthorized(false);
                    setLoading(false);
                    return;
                }

                // 2. Check Role if required
                if (requiredRole) {
                    const { data: profile } = await supabase
                        .from('profiles')
                        .select('role')
                        .eq('id', user.id)
                        .single();

                    if (profile?.role === requiredRole) {
                        setIsAuthorized(true);
                    } else {
                        setIsAuthorized(false);
                    }
                } else {
                    // Just authentication required
                    setIsAuthorized(true);
                }

            } catch (err) {
                console.error("Auth check failed:", err);
                setIsAuthorized(false);
            } finally {
                setLoading(false);
            }
        };

        checkAuth();
    }, [requiredRole]);

    if (loading) {
        return (
            <div className="h-screen flex items-center justify-center bg-slate-50">
                <div className="animate-spin h-8 w-8 border-4 border-blue-600 border-t-transparent rounded-full" />
            </div>
        );
    }

    if (!isAuthorized) {
        // If requiring admin but failing, force back to user dashboard
        if (requiredRole === 'admin') {
            return <Navigate to="/dashboard" replace />;
        }
        // Otherwise prompt login (saving location for redirect? maybe simple for now)
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
